import { Grid, Typography } from "@mui/material";
import OptionSelector from "../../OptionSelector";
import { FormInputText } from "@components/form";
import { Device } from "@/__generated__/graphql";
import { Control } from "react-hook-form";
import { FormValues } from "@features/createDeviceConfiguration/type/FormValues";

interface LGDeviceFormProps {
  device: Device;
  control: Control<FormValues>;
  sensorLevelOptions: any[];
  sensorAngleOptions: any[];
}

const LGDeviceForm = ({
  device,
  control,
  sensorLevelOptions,
  sensorAngleOptions,
}: LGDeviceFormProps) => {
  const childDevice = device?.relatedDevices?.find(rel => rel.relation === 'CHILD')?.device;
  const isParentDevice = !!childDevice;

  return (
    <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
      {(device.sensors ?? []).map((sensor, index) => (
        <Grid item xs={12} md={6} key={index}>
          <Typography variant="h6" color="textSecondary" mt={2} ml={1}>
            Sensor {index + 1} - {sensor?.type?.label}
          </Typography>
          <Grid item xs={12} mt={2}>
            <OptionSelector
              isDisabled={isParentDevice}
              options={
                sensor?.type?.name == 'level' ? sensorLevelOptions : sensorAngleOptions
              }
              label="Tipo de sensor *"
              name={`sensors[${index}].sensorModelOption`}
              control={control}
            />
          </Grid>
          <Grid item xs={12} mt={2}>
            <FormInputText
              disabled={isParentDevice}
              name={`sensors[${index}].serialNumber`}
              control={control}
              label="Número de serie del sensor"
            />
          </Grid>
          <Grid item xs={12} mt={2}>
            <FormInputText
              disabled={isParentDevice}
              name={`sensors[${index}].modbusId`}
              control={control}
              label="Modbus ID del sensor"
            />
          </Grid>
          <Grid item xs={12} mt={2}>
            <FormInputText
              disabled={isParentDevice}
              name={`sensors[${index}].batchNumber`}
              control={control}
              label="Número de lote del sensor"
            />
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
}

export default LGDeviceForm;
